import { DialogTitle } from '@headlessui/react'
import { XMarkIcon } from 'components/icons/Icons'

export interface PanelHeaderProps {
  title: string
  subtitle?: string
  onClose: () => void
}

const PanelHeader: React.FC<PanelHeaderProps> = ({
  title,
  subtitle,
  onClose
}) => (
  <div className="bg-primary px-4 py-6 sm:px-6">
    <div className="flex items-center justify-between">
      <DialogTitle className="text-2xl font-semibold text-white">
        {title}
      </DialogTitle>
      <div className="ml-3 flex h-7 items-center">
        <button
          type="button"
          onClick={onClose}
          className="relative rounded-md bg-primary dark:bg-transparent text-white dark:text-white hover:text-white focus:outline-none focus:ring-2 focus:ring-white"
        >
          <span className="absolute -inset-2.5" />
          <span className="sr-only">Close panel</span>
          <XMarkIcon aria-hidden="true" className="size-6" />
        </button>
      </div>
    </div>
    {subtitle && (
      <div className="mt-1">
        <p className="text-sm text-indigo-300 dark:text-zinc-300">{subtitle}</p>
      </div>
    )}
  </div>
)

export default PanelHeader
